// Copyright 2017 Sorama B.V.

export class WebGLExtensions {
    static ErrorToString(errorCode: number): string {
        switch (errorCode) {
            case WebGLRenderingContext.INVALID_ENUM:
                return "Invalid Enum: An unacceptable value has been specified for an enumerated argument";

            case WebGLRenderingContext.INVALID_VALUE:
                return "Invalid Value: A numeric argument is out of range";

            case WebGLRenderingContext.INVALID_OPERATION:
                return "Invalid Operation: The specified command is not allowed for the current state";

            case WebGLRenderingContext.INVALID_FRAMEBUFFER_OPERATION:
                return "Invalid Framebuffer Operation: The currently bound framebuffer is not framebuffer complete when trying to render to or to read from it";

            case WebGLRenderingContext.OUT_OF_MEMORY:
                return "Out of Memory: Not enough memory is left to execute the command";

            case WebGLRenderingContext.CONTEXT_LOST_WEBGL:
                return "Context Lost WebGL";

            default:
                return "No Error";
        }
    }

    static ThrowOnError(gl: WebGLRenderingContext): void {
        const error = gl.getError();
        if (error != WebGLRenderingContext.NO_ERROR) throw new Error(WebGLExtensions.ErrorToString(error));
    }
}
